/*
  Floretti — e-mailadres nooit als platte tekst in de HTML.
  De pagina levert alleen losse delen (gebruiker / domein / tld); dit script
  zet het adres client-side samen. Scrapers die HTML lezen zonder JS uit te
  voeren vinden geen adres; bezoekers zien en klikken het normaal.
*/
(function () {
  function hydrate() {
    var nodes = document.querySelectorAll('[data-mail-user][data-mail-domain]');
    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      var user = node.getAttribute('data-mail-user');
      var domain = node.getAttribute('data-mail-domain');
      var tld = node.getAttribute('data-mail-tld') || 'nl';
      if (!user || !domain) continue;
      var address = user + String.fromCharCode(64) + domain + '.' + tld;
      var label = node.querySelector('[data-mail-label]') || node;
      if (label.textContent !== address) label.textContent = address;
      if (node.tagName === 'A' && !node.getAttribute('href')) {
        var subject = node.getAttribute('data-mail-subject');
        node.setAttribute(
          'href',
          'mailto:' + address + (subject ? '?subject=' + encodeURIComponent(subject) : '')
        );
        node.setAttribute('rel', 'nofollow');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate, { once: true });
  } else {
    hydrate();
  }
}());
